import { createSlice } from '@reduxjs/toolkit'
import AppDataModel from "./AppDataModel";

const initialState: AppDataModel = {
    location: { id: 10, code: 'va01' },
    menus: [],
    products: [],
    productsPurchased: [],
    productsDic: {},
    schedule: { d0: [], d1: [], d2: [], d3: [], d4: [], d5: [], d6: [], exceptions: {} },
    productExtras: [],
    gp: {}
}

export const counterSlice = createSlice({
    name: 'appData',
    initialState,
    reducers: {
        reducerAppData: (state, action) => {
            state.menus = action.payload.menus
            state.products = action.payload.products
            state.productsPurchased = action.payload.productsPurchased
            state.productsDic = action.payload.productsDic
            state.schedule = action.payload.schedule
            state.location = action.payload.location
            state.productExtras = action.payload.productExtras
            state.gp = action.payload.gp
        },
        reducerAppDataUpdateProductRating: (state, action) => {
            const p = state.productsDic[action.payload.productCode]
            state.productsDic[action.payload.productCode] = action.payload.rating;
            state.products[p.indexCat].items[p.indexProduct].rating = action.payload.rating;
        }
    },
})
export const { reducerAppData, reducerAppDataUpdateProductRating } = counterSlice.actions
export default counterSlice.reducer

/*
const appLocationDataReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case APP_DATA:
            return {
                ...state,
                ...action.payload
            }
        case APP_DATA_UPDATE_PRODUCT_RATING:
            const data = {...state};
            const p = data.productsDic[action.payload.productCode]
            data.productsDic[action.payload.productCode] = action.payload.rating;
            data.products[p.indexCat].items[p.indexProduct].rating = action.payload.rating;
            return data;
    }
    return state;
}

export default appLocationDataReducer;
*/